import { render } from "./forgot-password-form.vue?vue&type=template&id=ac59a00e&scoped=true"
import script from "./forgot-password-form.vue?vue&type=script&lang=js"
export * from "./forgot-password-form.vue?vue&type=script&lang=js"

import "./forgot-password-form.vue?vue&type=style&index=0&id=ac59a00e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac59a00e"]])

export default __exports__